/**
 * Detect fn
 */
export default () => 'isNaN' in Number
